const ifNotEmpty = handler => val => {
  if (!val) {
    return null;
  }

  return handler(val);
};

export default ifNotEmpty;
